var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-categoryBarBox bread" }, [
    _c("div", { staticClass: "section-categoryBarCont" }, [
      _c("div", { staticClass: "section-categoryBarBgg" }, [
        _c(
          "div",
          { staticClass: "section-categoryBar" },
          [
            _c(
              "div",
              { staticClass: "section-categoryBar__menu" },
              [
                _c("v-breadcrumbs", {
                  attrs: { items: _vm.breadcrumbs },
                  scopedSlots: _vm._u([
                    {
                      key: "divider",
                      fn: function() {
                        return [_c("v-icon", [_vm._v("mdi-chevron-right")])]
                      },
                      proxy: true
                    }
                  ])
                })
              ],
              1
            ),
            _c("search-catalog-bar")
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }